import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PropertyMatrixSharedService } from 'src/app/property-matrix-shared.service';

@Component({
  selector: 'app-siod-confirm',
  templateUrl: './siod-confirm.component.html',
  styleUrls: ['./siod-confirm.component.scss']
})
export class SiodConfirmComponent implements OnInit {

  constructor(private router: Router, private sharedService: PropertyMatrixSharedService) { }

  ngOnInit(): void {
  }

  approveSubscription(){
    sessionStorage.setItem('siodPageNumber', '3');
    this.router.navigateByUrl('/share-in-our-database/capture');
  }

}